import React from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { ReactComponent as LockIcon } from 'new/components/icons/lock.svg';
import { ProfileImage } from 'new/elements/ProfileImage';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import LightningStatus from 'new/elements/LightningStatus';
import { ROUTE_CREDENTIALS } from 'new/constants/pathnames';
import { CREDENTIAL_UNTESTED } from 'js/constants/credentialStatus';
import styles from './CredentialWidget.module.scss';

type CredentialWidgetProps = {
  credentialId: number;
  credentialName: string;
  owner?: { id: number; full_name: string; email: string } | null;
  status?: 'valid' | 'invalid' | 'untested';
  className?: string;
};

export function CredentialWidget({
  credentialId,
  credentialName,
  owner,
  status = CREDENTIAL_UNTESTED,
  className,
}: CredentialWidgetProps) {
  return (
    <div className={cx(styles.widget, className)} data-testid="credential-widget">
      <div className={styles.left}>
        <LockIcon className={styles.icon} />
        <Link
          to={`${ROUTE_CREDENTIALS}/${credentialId}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.name}
          aria-label={`View credential: ${credentialName}`}
        >
          {credentialName}
        </Link>
        <ChipWithCopy
          toCopy={`${credentialId}`}
          tooltipTitle="Copy Credential ID"
          tooltipCopiedTitle="Credential ID Copied"
          placement="bottom-end"
        >
          ID {credentialId}
        </ChipWithCopy>
      </div>

      <div className={styles.separator} />

      <div className={styles.right}>
        {owner?.full_name && (
          <div className={styles.owner}>
            <ProfileImage
              fullName={owner.full_name}
              size="xsmall"
              color="var(--color-primary-700)"
            />
            <span className={styles.ownerName}>{owner.full_name}</span>
          </div>
        )}
        <LightningStatus status={status || CREDENTIAL_UNTESTED} />
      </div>
    </div>
  );
}
